import {Process} from "./process";

export class ProcessFlatNode extends Process {
    level: number;
    icon: string;
    expandable: boolean;
}
